import { useEffect, useRef } from "react";
import { useLocalStorage } from "../Components/Shared/Hooks/useLocalStorage";
import { log } from "../Utilities/logging";
import { configInitial, EdullaConfig } from "./configType";

const readTidFromScriptSrc = () => {
    try {
        const edullaScript = document.currentScript
        const edullaScriptSrc = edullaScript?.getAttribute('src') || "";
        const url = new URL(edullaScriptSrc)
        const queryParams = new URLSearchParams(url.search)
        const tid = queryParams.get('tid') || ''
        return tid
    }
    catch (e) {
        return ""
    }
}

export function useConfig() {
    let tid = window.sessionStorage.getItem("edullaTid");
    if (!tid || tid === "") {
        const queryParams = new URLSearchParams(window.location.search)
        tid = queryParams.get("tid") || readTidFromScriptSrc();
        tid = tid.replace("/", "");
        if (tid !== "")
            window.sessionStorage.setItem("edullaTid", tid);
    }
    const [config, setConfig] = useLocalStorage<EdullaConfig>(`edullaConfig-${tid}`, configInitial);

    const cachedConfigRef = useRef(config)

    useEffect(() => {
        cachedConfigRef.current = config
    }, [config])

    useEffect(() => {
        if (tid === "") {
            return
        }

        let isCancelled = false

        const fetchJson = async () => {
            try {
                const configBaseUrl = process.env.REACT_APP_CONFIG_BASE_URL ?? 'https://production-edulla-bot-interface.s3.amazonaws.com';
                const response = await fetch(`${configBaseUrl}/configs/${tid}.json`)
                if (!response.ok) throw new Error(`Config not found: ${response.status}`)
                const data = await response.json() as EdullaConfig

                if (isCancelled) {
                    return
                }

                if (JSON.stringify(cachedConfigRef.current) !== JSON.stringify(data)) {
                    setConfig(data)
                }
            }
            catch (e) {
                log("edulla-chat", (e as Error).message, "visitor", { sessionId: "", indexName: tid })
            }
        }

        fetchJson()

        return () => {
            isCancelled = true
        }
    }, [setConfig, tid])
    return config;
}
